// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__bXr4v","author":"Table_author__38s1s","authorImage":"Table_authorImage__23ejs","unreadRow":"Table_unreadRow__BK-v-"};